<template>
    <div class="zhuce2">
        <main>
            <div class="list">
                <h2>注册</h2>
                <van-cell-group inset>
                    <van-field v-model="tel" type="tel" label="登录手机" placeholder="请输入手机" />
                    <van-field v-model="name" label="姓名" placeholder="请输入姓名" />
                    <van-field v-model="password1" label="登录密码" placeholder="六位以上" />
                    <van-field v-model="password2" label="确认密码" placeholder="六位以上" />
                </van-cell-group>

                <footer>
                    <van-button type="danger" style="width:100%" @click="sub()" :disabled=disabled>确定</van-button>
                </footer>
            </div>
        </main>
    </div>
</template>

<script>
import { url2 } from '../router/api';

export default {
    data() {
        return {
            name:'',
            password1:'',
            tel:'',
            password2:'',
            disabled:true,
        }
    },

    watch: {
        formWatch(val) {
           if(val[0].length == 11 && val[0] && val[1] && val[2].length > 5 && val[2] == val[3]) {
                this.disabled = false
            } else {
                this.disabled = true
            }
        }
    },
    computed: {
        formWatch() {
            let arr = []
            arr.push(this.tel)
            arr.push(this.name)
            arr.push(this.password1)
            arr.push(this.password2)
            return arr
        },
    },
    
    mounted() {
       
    },
    methods: {
        sub() {
            this.axios.get(url2 + 'zhuCe2', {
                params:{
                    tel: this.tel,
                    name: this.name,
                    password: this.password1
                }
            }).then(res=> {
                if(res.data.code==1) {
                    this.$dialog.alert({
                        title: '提示',
                        message: '注册成功',
                    }).then(() => {
                        this.$router.push('./shen')
                    });
                } else {
                    this.$toast.fail({
                        message: res.data.msg,
                    })
                }
            }).catch(err=> {
                console.log(err);
            });
        },
    }
};
</script>
<style lang="less" scoped>
    .zhuce2 main {
        font-size: 14px;
        padding: 40px 16px 28px 16px;
        background-color: #FFDCA3;
    }
    .zhuce2 .list {
        background-color: #fff;
        padding: 20px;
        color: #EE0A24;
    }
    .zhuce2 h2 {
        text-align: center;
        margin-bottom: 20px;
    }

    .zhuce2 /deep/ .van-field__label {
        -webkit-box-flex: 0;
        -webkit-flex: none;
        flex: none;
        box-sizing: border-box;
        width: 6.2em;
        margin-right: 30px;
        color: #646566;
        text-align: left;
        word-wrap: break-word;
    }
  
    .zhuce2 /deep/ .van-uploader {
        position: relative;
        display: inline-block;
        margin-left: 16px;
    }

    .zhuce2 footer {
        margin-top: 20px;
        padding: 0 20px;
    }
</style>
